import React, {FC, useState} from "react"
import idHelper from "@irati/utils/id"
import Button from "@irati/ui/src/Button"
import Flex from "@irati/ui/src/Flex"
import {Deal} from "@irati/types"
import isCompanyBenefit from "@irati/deals/helpers/deals/isCompanyBenefit"
import FormattedMessage from "@irati/utils/lang"
import {hangPromise} from "@irati/utils/promise"
import Loading from "@irati/ui/src/Loading"
import withPerkOrReward, {WithPerkOrReward} from "@irati-web/flexi-rewards/src/utils/withPerkOrReward"
import {StyledSection} from "./styled/StyledSection"
import TimeLimitedDeal from "./TimeLimitedDeal"
import TTPaymentInfo from "./TTPaymentInfo"
import RPPaymentInfo from "./RPPaymentInfo"
import CashPaymentInfo from "./CashPaymentInfo"
import {OnDealSubmit} from "../../../../containers/DealInfo"
import RLOTError from "../../RLOTError"

interface Props extends WithPerkOrReward {
  id?: string,
  onSubmit: OnDealSubmit,
  deal: Deal
}

const StandardCTA: FC<Props> = ({deal, onSubmit, id, isRewards}: Props) => {
  const [submit, setSubmit] = useState<Promise<any> | null>(null)

  const handleSubmit = () => {
    setSubmit(onSubmit().then(() => hangPromise()))
  }

  let key = ""

  if (isRewards) {
    key = "perks.containers.dealImportantInfo.getReward"
  }
  else if (isCompanyBenefit(deal)) {
    key = "perks.containers.dealImportantInfo.getBenefit"
  }
  else {
    const [dealCurrency] = deal.productConfig!.products
    const flexiPerk = dealCurrency?.salePrice?.currency === "TT" && "perks.containers.dealImportantInfo.getFlexiPerk"
    const paidPerk = !flexiPerk && dealCurrency && "perks.containers.dealImportantInfo.selectVoucher"

    key = flexiPerk || paidPerk || "perks.containers.dealImportantInfo.getPerk"
  }

  return (
    <StyledSection>
      <TimeLimitedDeal deal={deal} />
      <TTPaymentInfo deal={deal} />
      <RPPaymentInfo />
      <CashPaymentInfo deal={deal} />
      <Flex direction="column" alignItems="center">
        <Loading load={submit} useLoader={false} Error={RLOTError} />
        <Button id={idHelper("getThisPerk", {id}, {force: true})} primary large full load={submit} onClick={handleSubmit}>
          <FormattedMessage id={key} />
        </Button>
      </Flex>
    </StyledSection>
  )
}

export default withPerkOrReward(StandardCTA)
